













import Vue from 'vue'
import { TextElInterface } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'TextEl',

  computed: {
    alignText (): string {
      return `text-align: ${this.$props.templateItemData.align || 'left'};`
    },
    fontSize (): string {
      let size: string
      switch (this.$props.templateItemData.size) {
        case 'large':
          size = '1.1rem'
          break
        case 'medium':
          size = '1.05rem'
          break
        default:
          size = '1rem'
          break
      }
      return `font-size: ${size};`
    },
    background (): string {
      return `background-color: ${this.$props.templateItemData.background || 'transparent'};`
    },
    color (): string {
      return `color: ${this.$props.templateItemData.color || (this.$vuetify.theme.dark
        ? darkColors.textColor : lightColors.primary)};`
    }
  },

  props: {
    templateItemData: {
      type: Object as () => TextElInterface,
      required: true
    }
  }
})
